import React from "react";

const SkeletonGrid = ({ count = 12 }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="relative rounded-2xl overflow-hidden h-36 bg-gray-200"
        >
          {/* Glass base */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-white/10 backdrop-blur-sm" />

          {/* Moving shimmer */}
          <div className="absolute inset-0 shimmer-effect" />
        </div>
      ))}
    </div>
  );
};

export default SkeletonGrid;
